import axios, { AxiosResponse } from "axios";
import { UpdatePasswordCredentials, UpdatePasswordResponse } from "./types";

export const updatePasswordMutation = async (
  {verification_token, checksum, password, confirm_password}: UpdatePasswordCredentials): Promise<AxiosResponse<UpdatePasswordResponse>> => {
  const response = await axios.post('/api/auth/update-password/', {verification_token, checksum, password, confirm_password}, {withCredentials: true})
  return response
}
